import styled from 'styled-components';
import { SubTitleText } from '../DTInfoWidget.styles';

export const CustomInfoSubTitleText = styled(SubTitleText)`
  margin-top: 15px;
`;
